import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import images from "../../../../images";
import Button from "../../../../components/common/Button/Button";

const StepQuestUnderReview = ({ questDetailsData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackHome = () => {
    const locationId =
      questDetailsData?.location_id || questDetailsData?.location?.id;

    if (locationId) {
      navigate(`/quest/location/${locationId}`);
    } else {
      navigate("/quest", { state: { direction: -1 } });
    }
  };

  return (
    <div className="flex flex-col flex-1 justify-between px-4 xs:px-[30px]">
      <div className="flex flex-col items-center justify-center flex-1 gap-4 xs:gap-6">
        <div className="text-center flex flex-col items-center gap-4 xs:gap-6">
          <div className="text-2xl xs:text-4xl font-bold text-primary tracking-[-0.72px]">
            Quest under review
          </div>
          <div className="text-base xs:text-xl font-medium text-primary">
            We'll keep you posted when <br />
            your points are ready!
          </div>
        </div>

        <div className="flex justify-center items-center">
          <img
            loading="lazy"
            src={images.QuestUnderReview}
            alt="Quest under review illustration"
            className="w-[150px] xs:w-[200px] h-auto object-contain"
          />
        </div>

        <div className="flex gap-3.5 items-start w-full">
          <Button
            onClick={handleBackHome}
            text={t("quest.taskQuest.exploreMoreQuests")}
            className="flex-1 w-full py-2.5 xs:py-3 rounded-md min-h-[40px] text-lg xs:text-xl font-medium text-[#253FF6] border border-[#253FF6]"
          />
        </div>
      </div>
    </div>
  );
};

export default StepQuestUnderReview;
